export default {
    EMISSIONS_TYPE_3: {
        title: '3',
        value: 0
    },
    EMISSIONS_TYPE_4: {
        title: '4',
        value: 1
    },
    EMISSIONS_TYPE_5: {
        title: '5',
        value: 2
    },
    EMISSIONS_TYPE_6A: {
        title: '6a',
        value: 3
    },
    EMISSIONS_TYPE_6B: {
        title: '6b',
        value: 4
    },
    EMISSIONS_TYPE_6C: {
        title: '6c',
        value: 5
    },
    EMISSIONS_TYPE_6D: {
        title: '6d',
        value: 6
    },
    toArray()
    {
        return [
            this.EMISSIONS_TYPE_3,
            this.EMISSIONS_TYPE_4,
            this.EMISSIONS_TYPE_5,
            this.EMISSIONS_TYPE_6A,
            this.EMISSIONS_TYPE_6B,
            this.EMISSIONS_TYPE_6C,
            this.EMISSIONS_TYPE_6D
        ];
    }
}